/**
 * This file is generated by the Angular 2 template compiler.
 * Do not edit.
 */
 /* tslint:disable */

import * as import0 from './admin-menu.component';
import * as import1 from '@angular/core/src/change_detection/change_detection';
import * as import2 from '@angular/core/src/linker/view_utils';
import * as import3 from '@angular/core/src/linker/view';
import * as import4 from '@angular/core/src/render/api';
import * as import5 from '@angular/core/src/linker/element';
import * as import6 from '@angular/core/src/di/injector';
import * as import7 from '@angular/core/src/linker/view_type';
import * as import8 from '../shared/utils.service';
import * as import9 from '@angular/core/src/metadata/view';
import * as import10 from '@angular/core/src/linker/component_factory';
import * as import11 from '../shared/search.component.ngfactory';
import * as import12 from '../shared/search.service';
import * as import13 from '../shared/search-elasticsearch.service';
import * as import14 from '@angular/router/src/router_state';
import * as import15 from '@angular/router/src/router';
import * as import16 from '../shared/search.component';
export class Wrapper_AdminMenuComponent {
  context:import0.AdminMenuComponent;
  changed:boolean;
  /*private*/ _expr_0:any;
  constructor(p0:any) {
    this.changed = false;
    this.context = new import0.AdminMenuComponent(p0);
    this._expr_0 = import1.UNINITIALIZED;
  }
  check_currentLanguage(currValue:any,throwOnChange:boolean,forceUpdate:boolean):void {
    if ((forceUpdate || import2.checkBinding(throwOnChange,this._expr_0,currValue))) {
      this.changed = true;
      this.context.currentLanguage = currValue;
      this._expr_0 = currValue;
    }
  }
  detectChangesInInputProps(view:import3.AppView<any>,el:any,throwOnChange:boolean):boolean {
    var changed:any = this.changed;
    this.changed = false;
    return changed;
  }
  detectChangesInHostProps(view:import3.AppView<any>,el:any,throwOnChange:boolean):void {
  }
}
var renderType_AdminMenuComponent_Host:import4.RenderComponentType = (null as any);
class _View_AdminMenuComponent_Host0 extends import3.AppView<any> {
  _el_0:any;
  /*private*/ _appEl_0:import5.AppElement;
  _AdminMenuComponent_0_4:Wrapper_AdminMenuComponent;
  constructor(viewUtils:import2.ViewUtils,parentInjector:import6.Injector,declarationEl:import5.AppElement) {
    super(_View_AdminMenuComponent_Host0,renderType_AdminMenuComponent_Host,import7.ViewType.HOST,viewUtils,parentInjector,declarationEl,import1.ChangeDetectorStatus.CheckAlways);
  }
  createInternal(rootSelector:string):import5.AppElement {
    this._el_0 = import2.selectOrCreateRenderHostElement(this.renderer,'admin-menu',import2.EMPTY_INLINE_ARRAY,rootSelector,(null as any));
    this._appEl_0 = new import5.AppElement(0,(null as any),this,this._el_0);
    var compView_0:any = viewFactory_AdminMenuComponent0(this.viewUtils,this.injector(0),this._appEl_0);
    this._AdminMenuComponent_0_4 = new Wrapper_AdminMenuComponent(this.parentInjector.get(import8.UtilsService));
    this._appEl_0.initComponent(this._AdminMenuComponent_0_4.context,([] as any[]),compView_0);
    compView_0.create(this._AdminMenuComponent_0_4.context,this.projectableNodes,(null as any));
    this.init(([] as any[]).concat([this._el_0]),[this._el_0],([] as any[]),([] as any[]));
    return this._appEl_0;
  }
  injectorGetInternal(token:any,requestNodeIndex:number,notFoundResult:any):any {
    if (((token === import0.AdminMenuComponent) && (0 === requestNodeIndex))) { return this._AdminMenuComponent_0_4.context; }
    return notFoundResult;
  }
  detectChangesInternal(throwOnChange:boolean):void {
    this._AdminMenuComponent_0_4.detectChangesInInputProps(this,this._el_0,throwOnChange);
    this.detectContentChildrenChanges(throwOnChange);
    this._AdminMenuComponent_0_4.detectChangesInHostProps(this,this._el_0,throwOnChange);
    this.detectViewChildrenChanges(throwOnChange);
  }
}
function viewFactory_AdminMenuComponent_Host0(viewUtils:import2.ViewUtils,parentInjector:import6.Injector,declarationEl:import5.AppElement):import3.AppView<any> {
  if ((renderType_AdminMenuComponent_Host === (null as any))) { (renderType_AdminMenuComponent_Host = viewUtils.createRenderComponentType('',0,import9.ViewEncapsulation.None,([] as any[]),{})); }
  return new _View_AdminMenuComponent_Host0(viewUtils,parentInjector,declarationEl);
}
export const AdminMenuComponentNgFactory:import10.ComponentFactory<import0.AdminMenuComponent> = new import10.ComponentFactory<import0.AdminMenuComponent>('admin-menu',viewFactory_AdminMenuComponent_Host0,import0.AdminMenuComponent);
const styles_AdminMenuComponent:any[] = ([] as any[]);
var renderType_AdminMenuComponent:import4.RenderComponentType = (null as any);
class _View_AdminMenuComponent0 extends import3.AppView<import0.AdminMenuComponent> {
  _text_0:any;
  _text_1:any;
  _el_2:any;
  _text_3:any;
  _text_4:any;
  _el_5:any;
  _text_6:any;
  _el_7:any;
  /*private*/ _appEl_7:import5.AppElement;
  _SearchComponent_7_4:import11.Wrapper_SearchComponent;
  _text_8:any;
  _text_9:any;
  _text_10:any;
  _el_11:any;
  _text_12:any;
  _text_13:any;
  _el_14:any;
  _text_15:any;
  _el_16:any;
  _el_17:any;
  _text_18:any;
  _el_19:any;
  _text_20:any;
  _text_21:any;
  _text_22:any;
  _text_23:any;
  _el_24:any;
  _text_25:any;
  _el_26:any;
  _text_27:any;
  _el_28:any;
  _text_29:any;
  _el_30:any;
  _text_31:any;
  _text_32:any;
  _el_33:any;
  _text_34:any;
  _el_35:any;
  _text_36:any;
  _text_37:any;
  _text_38:any;
  _el_39:any;
  _text_40:any;
  _el_41:any;
  _el_42:any;
  _el_43:any;
  _text_44:any;
  _text_45:any;
  _el_46:any;
  _el_47:any;
  _el_48:any;
  _text_49:any;
  _text_50:any;
  _el_51:any;
  _el_52:any;
  _el_53:any;
  _text_54:any;
  _text_55:any;
  _el_56:any;
  _el_57:any;
  _el_58:any;
  _text_59:any;
  _text_60:any;
  _text_61:any;
  _text_62:any;
  _el_63:any;
  _text_64:any;
  _el_65:any;
  _el_66:any;
  _text_67:any;
  _el_68:any;
  _text_69:any;
  _text_70:any;
  _text_71:any;
  _text_72:any;
  _el_73:any;
  _text_74:any;
  _el_75:any;
  _el_76:any;
  _text_77:any;
  _el_78:any;
  _text_79:any;
  _text_80:any;
  _text_81:any;
  _text_82:any;
  _el_83:any;
  _text_84:any;
  _el_85:any;
  _el_86:any;
  _text_87:any;
  _el_88:any;
  _text_89:any;
  _text_90:any;
  _text_91:any;
  _text_92:any;
  _el_93:any;
  _text_94:any;
  _el_95:any;
  _el_96:any;
  _text_97:any;
  _el_98:any;
  _text_99:any;
  _text_100:any;
  _text_101:any;
  _text_102:any;
  _text_103:any;
  _text_104:any;
  _text_105:any;
  _text_106:any;
  _arr_109:any;
  constructor(viewUtils:import2.ViewUtils,parentInjector:import6.Injector,declarationEl:import5.AppElement) {
    super(_View_AdminMenuComponent0,renderType_AdminMenuComponent,import7.ViewType.COMPONENT,viewUtils,parentInjector,declarationEl,import1.ChangeDetectorStatus.CheckAlways);
    this._arr_109 = import2.pureProxy3((p0:any,p1:any,p2:any):any[] => {
      return [
        p0,
        p1,
        p2
      ]
      ;
    });
  }
  createInternal(rootSelector:string):import5.AppElement {
    const parentRenderNode:any = this.renderer.createViewRoot(this.declarationAppElement.nativeElement);
    this._text_0 = this.renderer.createText(parentRenderNode,'      ',(null as any));
    this._text_1 = this.renderer.createText(parentRenderNode,'\n      ',(null as any));
    this._el_2 = import2.createRenderElement(this.renderer,parentRenderNode,'aside',new import2.InlineArray2(2,'class','main-sidebar'),(null as any));
    this._text_3 = this.renderer.createText(this._el_2,'\n\n        ',(null as any));
    this._text_4 = this.renderer.createText(this._el_2,'\n        ',(null as any));
    this._el_5 = import2.createRenderElement(this.renderer,this._el_2,'section',new import2.InlineArray2(2,'class','sidebar'),(null as any));
    this._text_6 = this.renderer.createText(this._el_5,' \n\n          ',(null as any));
    this._el_7 = import2.createRenderElement(this.renderer,this._el_5,'search',new import2.InlineArray4(4,'placeholder','Rechercher','target','admin/records'),(null as any));
    this._appEl_7 = new import5.AppElement(7,5,this,this._el_7);
    var compView_7:any = import11.viewFactory_SearchComponent0(this.viewUtils,this.injector(7),this._appEl_7);
    this._SearchComponent_7_4 = new import11.Wrapper_SearchComponent(this.parentInjector.get(import8.UtilsService),this.parentInjector.get(import12.SearchService),this.parentInjector.get(import13.ElasticSearchService),this.parentInjector.get(import14.ActivatedRoute),this.parentInjector.get(import15.Router));
    this._appEl_7.initComponent(this._SearchComponent_7_4.context,([] as any[]),compView_7);
    this._text_8 = this.renderer.createText((null as any),'\n          ',(null as any));
    compView_7.create(this._SearchComponent_7_4.context,([] as any[]),(null as any));
    this._text_9 = this.renderer.createText(this._el_5,'\n\n          ',(null as any));
    this._text_10 = this.renderer.createText(this._el_5,' \n          ',(null as any));
    this._el_11 = import2.createRenderElement(this.renderer,this._el_5,'ul',new import2.InlineArray2(2,'class','sidebar-menu'),(null as any));
    this._text_12 = this.renderer.createText(this._el_11,'\n            ',(null as any));
    this._text_13 = this.renderer.createText(this._el_11,'\n            ',(null as any));
    this._el_14 = import2.createRenderElement(this.renderer,this._el_11,'li',new import2.InlineArray2(2,'class','treeview'),(null as any));
    this._text_15 = this.renderer.createText(this._el_14,'\n                ',(null as any));
    this._el_16 = import2.createRenderElement(this.renderer,this._el_14,'a',new import2.InlineArray2(2,'class','lLink'),(null as any));
    this._el_17 = import2.createRenderElement(this.renderer,this._el_16,'i',new import2.InlineArray2(2,'class','glyphicon glyphicon-cd'),(null as any));
    this._text_18 = this.renderer.createText(this._el_16,'\n                  ',(null as any));
    this._el_19 = import2.createRenderElement(this.renderer,this._el_16,'span',import2.EMPTY_INLINE_ARRAY,(null as any));
    this._text_20 = this.renderer.createText(this._el_19,'Nouveau disque',(null as any));
    this._text_21 = this.renderer.createText(this._el_16,'\n                ',(null as any));
    this._text_22 = this.renderer.createText(this._el_14,'\n            ',(null as any));
    this._text_23 = this.renderer.createText(this._el_11,'\n            ',(null as any));
    this._el_24 = import2.createRenderElement(this.renderer,this._el_11,'li',new import2.InlineArray2(2,'class','treeview'),(null as any));
    this._text_25 = this.renderer.createText(this._el_24,'\n                ',(null as any));
    this._el_26 = import2.createRenderElement(this.renderer,this._el_24,'a',new import2.InlineArray2(2,'href','#'),(null as any));
    this._text_27 = this.renderer.createText(this._el_26,'\n                  ',(null as any));
    this._el_28 = import2.createRenderElement(this.renderer,this._el_26,'i',new import2.InlineArray2(2,'class','glyphicon glyphicon-list'),(null as any));
    this._text_29 = this.renderer.createText(this._el_26,'\n                  ',(null as any));
    this._el_30 = import2.createRenderElement(this.renderer,this._el_26,'span',import2.EMPTY_INLINE_ARRAY,(null as any));
    this._text_31 = this.renderer.createText(this._el_30,'Catalogue',(null as any));
    this._text_32 = this.renderer.createText(this._el_26,'\n                  ',(null as any));
    this._el_33 = import2.createRenderElement(this.renderer,this._el_26,'span',new import2.InlineArray2(2,'class','pull-right-container'),(null as any));
    this._text_34 = this.renderer.createText(this._el_33,'\n                    ',(null as any));
    this._el_35 = import2.createRenderElement(this.renderer,this._el_33,'i',new import2.InlineArray2(2,'class','fa fa-angle-left pull-right'),(null as any));
    this._text_36 = this.renderer.createText(this._el_33,'\n                  ',(null as any));
    this._text_37 = this.renderer.createText(this._el_26,'\n                ',(null as any));
    this._text_38 = this.renderer.createText(this._el_24,'\n                ',(null as any));
    this._el_39 = import2.createRenderElement(this.renderer,this._el_24,'ul',new import2.InlineArray2(2,'class','treeview-menu'),(null as any));
    this._text_40 = this.renderer.createText(this._el_39,'\n                  ',(null as any));
    this._el_41 = import2.createRenderElement(this.renderer,this._el_39,'li',import2.EMPTY_INLINE_ARRAY,(null as any));
    this._el_42 = import2.createRenderElement(this.renderer,this._el_41,'a',new import2.InlineArray2(2,'class','lLink'),(null as any));
    this._el_43 = import2.createRenderElement(this.renderer,this._el_42,'i',new import2.InlineArray2(2,'class','fa fa-circle-o'),(null as any));
    this._text_44 = this.renderer.createText(this._el_42,' Tout le catalogue',(null as any));
    this._text_45 = this.renderer.createText(this._el_39,'\n                  ',(null as any));
    this._el_46 = import2.createRenderElement(this.renderer,this._el_39,'li',import2.EMPTY_INLINE_ARRAY,(null as any));
    this._el_47 = import2.createRenderElement(this.renderer,this._el_46,'a',new import2.InlineArray2(2,'class','lLink'),(null as any));
    this._el_48 = import2.createRenderElement(this.renderer,this._el_47,'i',new import2.InlineArray2(2,'class','fa fa-circle-o'),(null as any));
    this._text_49 = this.renderer.createText(this._el_47,' Interprètes d\'hier',(null as any));
    this._text_50 = this.renderer.createText(this._el_39,'\n                  ',(null as any));
    this._el_51 = import2.createRenderElement(this.renderer,this._el_39,'li',import2.EMPTY_INLINE_ARRAY,(null as any));
    this._el_52 = import2.createRenderElement(this.renderer,this._el_51,'a',new import2.InlineArray2(2,'class','lLink'),(null as any));
    this._el_53 = import2.createRenderElement(this.renderer,this._el_52,'i',new import2.InlineArray2(2,'class','fa fa-circle-o'),(null as any));
    this._text_54 = this.renderer.createText(this._el_52,' Interprètes d\'aujourd\'hui',(null as any));
    this._text_55 = this.renderer.createText(this._el_39,'\n                  ',(null as any));
    this._el_56 = import2.createRenderElement(this.renderer,this._el_39,'li',import2.EMPTY_INLINE_ARRAY,(null as any));
    this._el_57 = import2.createRenderElement(this.renderer,this._el_56,'a',new import2.InlineArray2(2,'class','lLink'),(null as any));
    this._el_58 = import2.createRenderElement(this.renderer,this._el_57,'i',new import2.InlineArray2(2,'class','fa fa-circle-o'),(null as any));
    this._text_59 = this.renderer.createText(this._el_57,' Non-publié',(null as any));
    this._text_60 = this.renderer.createText(this._el_39,'\n                ',(null as any));
    this._text_61 = this.renderer.createText(this._el_24,'\n              ',(null as any));
    this._text_62 = this.renderer.createText(this._el_11,'\n            ',(null as any));
    this._el_63 = import2.createRenderElement(this.renderer,this._el_11,'li',new import2.InlineArray2(2,'class','treeview'),(null as any));
    this._text_64 = this.renderer.createText(this._el_63,'\n              ',(null as any));
    this._el_65 = import2.createRenderElement(this.renderer,this._el_63,'a',new import2.InlineArray2(2,'class','lLink'),(null as any));
    this._el_66 = import2.createRenderElement(this.renderer,this._el_65,'i',new import2.InlineArray2(2,'class','glyphicon glyphicon-star'),(null as any));
    this._text_67 = this.renderer.createText(this._el_65,'\n                ',(null as any));
    this._el_68 = import2.createRenderElement(this.renderer,this._el_65,'span',import2.EMPTY_INLINE_ARRAY,(null as any));
    this._text_69 = this.renderer.createText(this._el_68,'Parmi les interprètes',(null as any));
    this._text_70 = this.renderer.createText(this._el_65,'\n              ',(null as any));
    this._text_71 = this.renderer.createText(this._el_63,'\n            ',(null as any));
    this._text_72 = this.renderer.createText(this._el_11,'\n            ',(null as any));
    this._el_73 = import2.createRenderElement(this.renderer,this._el_11,'li',new import2.InlineArray2(2,'class','treeview'),(null as any));
    this._text_74 = this.renderer.createText(this._el_73,'\n                ',(null as any));
    this._el_75 = import2.createRenderElement(this.renderer,this._el_73,'a',new import2.InlineArray2(2,'class','lLink'),(null as any));
    this._el_76 = import2.createRenderElement(this.renderer,this._el_75,'i',new import2.InlineArray2(2,'class','glyphicon glyphicon-text-size'),(null as any));
    this._text_77 = this.renderer.createText(this._el_75,'\n                  ',(null as any));
    this._el_78 = import2.createRenderElement(this.renderer,this._el_75,'span',import2.EMPTY_INLINE_ARRAY,(null as any));
    this._text_79 = this.renderer.createText(this._el_78,'Ecrits',(null as any));
    this._text_80 = this.renderer.createText(this._el_75,'\n                ',(null as any));
    this._text_81 = this.renderer.createText(this._el_73,'\n            ',(null as any));
    this._text_82 = this.renderer.createText(this._el_11,'\n            ',(null as any));
    this._el_83 = import2.createRenderElement(this.renderer,this._el_11,'li',new import2.InlineArray2(2,'class','treeview'),(null as any));
    this._text_84 = this.renderer.createText(this._el_83,'\n                ',(null as any));
    this._el_85 = import2.createRenderElement(this.renderer,this._el_83,'a',new import2.InlineArray2(2,'class','lLink'),(null as any));
    this._el_86 = import2.createRenderElement(this.renderer,this._el_85,'i',new import2.InlineArray2(2,'class','glyphicon glyphicon-paperclip'),(null as any));
    this._text_87 = this.renderer.createText(this._el_85,'\n                  ',(null as any));
    this._el_88 = import2.createRenderElement(this.renderer,this._el_85,'span',import2.EMPTY_INLINE_ARRAY,(null as any));
    this._text_89 = this.renderer.createText(this._el_88,'Messages',(null as any));
    this._text_90 = this.renderer.createText(this._el_85,'\n                ',(null as any));
    this._text_91 = this.renderer.createText(this._el_83,'\n            ',(null as any));
    this._text_92 = this.renderer.createText(this._el_11,'\n            ',(null as any));
    this._el_93 = import2.createRenderElement(this.renderer,this._el_11,'li',new import2.InlineArray2(2,'class','treeview'),(null as any));
    this._text_94 = this.renderer.createText(this._el_93,'\n                ',(null as any));
    this._el_95 = import2.createRenderElement(this.renderer,this._el_93,'a',new import2.InlineArray2(2,'class','lLink'),(null as any));
    this._el_96 = import2.createRenderElement(this.renderer,this._el_95,'i',new import2.InlineArray2(2,'class','glyphicon glyphicon-file'),(null as any));
    this._text_97 = this.renderer.createText(this._el_95,'\n                  ',(null as any));
    this._el_98 = import2.createRenderElement(this.renderer,this._el_95,'span',import2.EMPTY_INLINE_ARRAY,(null as any));
    this._text_99 = this.renderer.createText(this._el_98,'Pages',(null as any));
    this._text_100 = this.renderer.createText(this._el_95,'\n                ',(null as any));
    this._text_101 = this.renderer.createText(this._el_93,'\n              ',(null as any));
    this._text_102 = this.renderer.createText(this._el_11,'\n          ',(null as any));
    this._text_103 = this.renderer.createText(this._el_5,'\n          ',(null as any));
    this._text_104 = this.renderer.createText(this._el_5,'\n        ',(null as any));
    this._text_105 = this.renderer.createText(this._el_2,'\n        ',(null as any));
    this._text_106 = this.renderer.createText(this._el_2,'\n      ',(null as any));
    var disposable_0:Function = this.renderer.listen(this._el_16,'click',this.eventHandler(this._handle_click_16_0.bind(this)));
    var disposable_1:Function = this.renderer.listen(this._el_42,'click',this.eventHandler(this._handle_click_42_0.bind(this)));
    var disposable_2:Function = this.renderer.listen(this._el_47,'click',this.eventHandler(this._handle_click_47_0.bind(this)));
    var disposable_3:Function = this.renderer.listen(this._el_52,'click',this.eventHandler(this._handle_click_52_0.bind(this)));
    var disposable_4:Function = this.renderer.listen(this._el_57,'click',this.eventHandler(this._handle_click_57_0.bind(this)));
    var disposable_5:Function = this.renderer.listen(this._el_65,'click',this.eventHandler(this._handle_click_65_0.bind(this)));
    var disposable_6:Function = this.renderer.listen(this._el_75,'click',this.eventHandler(this._handle_click_75_0.bind(this)));
    var disposable_7:Function = this.renderer.listen(this._el_85,'click',this.eventHandler(this._handle_click_85_0.bind(this)));
    var disposable_8:Function = this.renderer.listen(this._el_95,'click',this.eventHandler(this._handle_click_95_0.bind(this)));
    this.init(([] as any[]),[
      this._text_0,
      this._text_1,
      this._el_2,
      this._text_3,
      this._text_4,
      this._el_5,
      this._text_6,
      this._el_7,
      this._text_8,
      this._text_9,
      this._text_10,
      this._el_11,
      this._text_12,
      this._text_13,
      this._el_14,
      this._text_15,
      this._el_16,
      this._el_17,
      this._text_18,
      this._el_19,
      this._text_20,
      this._text_21,
      this._text_22,
      this._text_23,
      this._el_24,
      this._text_25,
      this._el_26,
      this._text_27,
      this._el_28,
      this._text_29,
      this._el_30,
      this._text_31,
      this._text_32,
      this._el_33,
      this._text_34,
      this._el_35,
      this._text_36,
      this._text_37,
      this._text_38,
      this._el_39,
      this._text_40,
      this._el_41,
      this._el_42,
      this._el_43,
      this._text_44,
      this._text_45,
      this._el_46,
      this._el_47,
      this._el_48,
      this._text_49,
      this._text_50,
      this._el_51,
      this._el_52,
      this._el_53,
      this._text_54,
      this._text_55,
      this._el_56,
      this._el_57,
      this._el_58,
      this._text_59,
      this._text_60,
      this._text_61,
      this._text_62,
      this._el_63,
      this._text_64,
      this._el_65,
      this._el_66,
      this._text_67,
      this._el_68,
      this._text_69,
      this._text_70,
      this._text_71,
      this._text_72,
      this._el_73,
      this._text_74,
      this._el_75,
      this._el_76,
      this._text_77,
      this._el_78,
      this._text_79,
      this._text_80,
      this._text_81,
      this._text_82,
      this._el_83,
      this._text_84,
      this._el_85,
      this._el_86,
      this._text_87,
      this._el_88,
      this._text_89,
      this._text_90,
      this._text_91,
      this._text_92,
      this._el_93,
      this._text_94,
      this._el_95,
      this._el_96,
      this._text_97,
      this._el_98,
      this._text_99,
      this._text_100,
      this._text_101,
      this._text_102,
      this._text_103,
      this._text_104,
      this._text_105,
      this._text_106
    ]
    ,[
      disposable_0,
      disposable_1,
      disposable_2,
      disposable_3,
      disposable_4,
      disposable_5,
      disposable_6,
      disposable_7,
      disposable_8
    ]
    ,([] as any[]));
    return (null as any);
  }
  injectorGetInternal(token:any,requestNodeIndex:number,notFoundResult:any):any {
    if (((token === import16.SearchComponent) && ((7 <= requestNodeIndex) && (requestNodeIndex <= 8)))) { return this._SearchComponent_7_4.context; }
    return notFoundResult;
  }
  detectChangesInternal(throwOnChange:boolean):void {
    const currVal_7_0_0:any = this._arr_109('composer','soloist','conductor');
    this._SearchComponent_7_4.check_order(currVal_7_0_0,throwOnChange,false);
    const currVal_7_0_1:any = 'admin/records';
    this._SearchComponent_7_4.check_target(currVal_7_0_1,throwOnChange,false);
    const currVal_7_0_2:any = 'Rechercher';
    this._SearchComponent_7_4.check_placeholder(currVal_7_0_2,throwOnChange,false);
    const currVal_7_0_3:any = this.context.currentLanguage;
    this._SearchComponent_7_4.check_language(currVal_7_0_3,throwOnChange,false);
    this._SearchComponent_7_4.detectChangesInInputProps(this,this._el_7,throwOnChange);
    this.detectContentChildrenChanges(throwOnChange);
    this._SearchComponent_7_4.detectChangesInHostProps(this,this._el_7,throwOnChange);
    this.detectViewChildrenChanges(throwOnChange);
  }
  private _handle_click_16_0($event:any):boolean {
    this.markPathToRootAsCheckOnce();
    const pd_16_0:any = ((<any>this.context.utils.lLink('admin/record/edit/0',this.context.currentLanguage)) !== false);
    return (true && pd_16_0);
  }
  private _handle_click_42_0($event:any):boolean {
    this.markPathToRootAsCheckOnce();
    const pd_42_0:any = ((<any>this.context.utils.lLink('admin/records',this.context.currentLanguage)) !== false);
    return (true && pd_42_0);
  }
  private _handle_click_47_0($event:any):boolean {
    this.markPathToRootAsCheckOnce();
    const pd_47_0:any = ((<any>this.context.utils.lLink('admin/records?f=type~reissue',this.context.currentLanguage)) !== false);
    return (true && pd_47_0);
  }
  private _handle_click_52_0($event:any):boolean {
    this.markPathToRootAsCheckOnce();
    const pd_52_0:any = ((<any>this.context.utils.lLink('admin/records?f=type~production',this.context.currentLanguage)) !== false);
    return (true && pd_52_0);
  }
  private _handle_click_57_0($event:any):boolean {
    this.markPathToRootAsCheckOnce();
    const pd_57_0:any = ((<any>this.context.utils.lLink('admin/records/active/false',this.context.currentLanguage)) !== false);
    return (true && pd_57_0);
  }
  private _handle_click_65_0($event:any):boolean {
    this.markPathToRootAsCheckOnce();
    const pd_65_0:any = ((<any>this.context.utils.lLink('admin/specials',this.context.currentLanguage)) !== false);
    return (true && pd_65_0);
  }
  private _handle_click_75_0($event:any):boolean {
    this.markPathToRootAsCheckOnce();
    const pd_75_0:any = ((<any>this.context.utils.lLink('admin/writings',this.context.currentLanguage)) !== false);
    return (true && pd_75_0);
  }
  private _handle_click_85_0($event:any):boolean {
    this.markPathToRootAsCheckOnce();
    const pd_85_0:any = ((<any>this.context.utils.lLink('admin/messages',this.context.currentLanguage)) !== false);
    return (true && pd_85_0);
  }
  private _handle_click_95_0($event:any):boolean {
    this.markPathToRootAsCheckOnce();
    const pd_95_0:any = ((<any>this.context.utils.lLink('admin/pages',this.context.currentLanguage)) !== false);
    return (true && pd_95_0);
  }
}
export function viewFactory_AdminMenuComponent0(viewUtils:import2.ViewUtils,parentInjector:import6.Injector,declarationEl:import5.AppElement):import3.AppView<import0.AdminMenuComponent> {
  if ((renderType_AdminMenuComponent === (null as any))) { (renderType_AdminMenuComponent = viewUtils.createRenderComponentType('',0,import9.ViewEncapsulation.None,styles_AdminMenuComponent,{})); }
  return new _View_AdminMenuComponent0(viewUtils,parentInjector,declarationEl);
}


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/admin/admin-menu.component.ngfactory.ts